export const TITLE = "Piaggio E-Xtra FX Max Price in 2026 - Range, Specification & Reviews | Turno";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Piaggio E-Xtra FX Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "Piaggio E-Xtra FX Max, Piaggio electric vehicle, Piaggio electric cargo vehicle, Piaggio electric commercial vehicle, Piaggio E-Xtra FX Max price, Piaggio E-Xtra FX Max specifications, Piaggio E-Xtra FX Max range, Piaggio E-Xtra FX Max load capacity, Piaggio electric vehicle price, Piaggio commercial vehicle, Piaggio electric auto, Piaggio EV, Piaggio electric truck, Piaggio cargo vehicle, Piaggio electric vehicle specifications, Piaggio electric vehicle features, Piaggio electric vehicle reviews, Piaggio electric vehicle dealer, Piaggio Ape E-Xtra FX Max, Piaggio electric three wheeler, Piaggio electric loader",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Piaggio E-Xtra FX Max Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Piaggio E-Xtra FX Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Piaggio E-Xtra FX Max price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Piaggio E-Xtra FX Max Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Piaggio/E-Xtra-FX-Max";

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADING = "Product Highlights";

export const HIGHLIGHTS_DESCRIPTION = "The Piaggio Ape E-Xtra Fx Max Electric Commercial Auto is a game-changer in the world of cargo transportation. The Piaggio Ape E-Xtra Fx Max electric loader has a high payload capacity of 550 kgs and a 115 km/charge range to make your delivery experience hassle-free. This electric three-wheeler tempo is highly customizable and can also be converted into a DV, so you can pick the kind that suits your business needs.";

export const MOSTLY_BOUGHT_FOR_HEADING = "Mostly bought for";

export const BUSINESS_BENEFIT_HEADING = "Business Benefit with Electric Vehicle";

export const FEATURES_HEADING = "Features of Piaggio E-Xtra FX Max";

export const BRAND_DEALER_HEADING = "Piaggio E-Xtra FX Max Electric Truck Dealers Near Me:";

export const BRAND_DEALER_DESCRIPITION = "As Piaggio's influence continues to extend across India, its presence is becoming increasingly noticeable. With a rising number of individuals choosing Piaggio's top-notch mobility solutions, known for delivering excellent value for the price, Turno proudly presents the outstanding Piaggio E-Xtra FX Max electric commercial vehicle, at an unbelievably budget-friendly price.";

export const FAQ_HEADING_TEXT = "FAQs on Piaggio E-Xtra FX Max";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Piaggio", href: "/electric-commercial-vehicles/Piaggio" },
  { label: "E-Xtra FX Max" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Piaggio",
      item: "https://www.turno.club/electric-commercial-vehicles/Piaggio",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "E-Xtra FX Max",
      item: VEHICLE_LINK,
    },
  ],
};
